
export default {
  scrollToTop: true,
  async asyncData({ $axios, route, error }) {
    try {
      const stream = await $axios.$get(`/stream/${route.params.url}/profile`)
      if (stream?.stream?.type !== 'PRODUCT') {
        error({
          statusCode: 404,
          message: 'Обзор не найден',
        })
      }
      return { stream }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },
  data() {
    return {
      stream: null,
    }
  },
  methods: {
    async changeStreamCover(cover) {
      this.stream.stream.cover = cover
      this.stream.stream._id = this.stream.stream.id
      await this.saveStream()
    },
    async updateStreamAvatar(avatar) {
      this.stream.stream.avatar = avatar
      this.stream.stream._id = this.stream.stream.id
      await this.saveStream()
    },

    async saveStream() {
      await this.$axios.$put('/stream', this.stream.stream)
      await this.fetchStream()
    },

    subscribe() {
      this.$eventBus.$emit('Product-subscribe', this.stream.stream)
      this.fetchStream()
    },
    unSubscribe() {
      this.$eventBus.$emit('Product-unSubscribe', this.stream.stream)
      this.fetchStream()
    },

    async fetchStream() {
      const stream = await this.$axios.$get(
        `/stream/${this.$route.params.url}/profile`
      )
      this.stream = stream
    },
  },
}
